var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconProductGallery(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "160px",
    height: "108px",
    viewBox: "0 0 160 108",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Product Gallery") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Row-Menu",
    transform: "translate(-48.000000, -730.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Product-Gallery",
    transform: "translate(48.000000, 730.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#CDD4DA",
    x: 0.5,
    y: 0.5,
    width: 159,
    height: 107
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    fill: "#8C9BA8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 34,
    height: 96
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon/Tag/M/White-Default",
    transform: "translate(5.000000, 36.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.87,22 C12.3871126,21.9994508 11.9237947,21.8090954 11.58,21.47 L5.17,15.05 C5.0055124,14.886454 4.90299461,14.6708131 4.88,14.44 L4,5.09 C3.97272602,4.79345526 4.07903692,4.5001838 4.29,4.29 C4.5001838,4.07903692 4.79345526,3.97272602 5.09,4 L14.44,4.88 C14.6708131,4.90299461 14.886454,5.0055124 15.05,5.17 L21.47,11.58 C22.178179,12.2903094 22.178179,13.4396906 21.47,14.15 L14.15,21.47 C13.8098855,21.8084982 13.349852,21.9989808 12.87,22 L12.87,22 Z M6.87,13.89 L12.87,19.89 L19.92,12.84 L13.92,6.84 L6.11,6.11 L6.87,13.89 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#000000",
    fillRule: "nonzero",
    cx: 10.5,
    cy: 10.5,
    r: 1.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(44.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    fill: "#8C9BA8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 34,
    height: 96
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon/Tag/M/White-Default",
    transform: "translate(5.000000, 36.000000)",
    filter: "url(#filter-2)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.87,22 C12.3871126,21.9994508 11.9237947,21.8090954 11.58,21.47 L5.17,15.05 C5.0055124,14.886454 4.90299461,14.6708131 4.88,14.44 L4,5.09 C3.97272602,4.79345526 4.07903692,4.5001838 4.29,4.29 C4.5001838,4.07903692 4.79345526,3.97272602 5.09,4 L14.44,4.88 C14.6708131,4.90299461 14.886454,5.0055124 15.05,5.17 L21.47,11.58 C22.178179,12.2903094 22.178179,13.4396906 21.47,14.15 L14.15,21.47 C13.8098855,21.8084982 13.349852,21.9989808 12.87,22 L12.87,22 Z M6.87,13.89 L12.87,19.89 L19.92,12.84 L13.92,6.84 L6.11,6.11 L6.87,13.89 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#000000",
    fillRule: "nonzero",
    cx: 10.5,
    cy: 10.5,
    r: 1.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(82.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    fill: "#8C9BA8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 34,
    height: 96
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon/Tag/M/White-Default",
    transform: "translate(5.000000, 36.000000)",
    filter: "url(#filter-3)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.87,22 C12.3871126,21.9994508 11.9237947,21.8090954 11.58,21.47 L5.17,15.05 C5.0055124,14.886454 4.90299461,14.6708131 4.88,14.44 L4,5.09 C3.97272602,4.79345526 4.07903692,4.5001838 4.29,4.29 C4.5001838,4.07903692 4.79345526,3.97272602 5.09,4 L14.44,4.88 C14.6708131,4.90299461 14.886454,5.0055124 15.05,5.17 L21.47,11.58 C22.178179,12.2903094 22.178179,13.4396906 21.47,14.15 L14.15,21.47 C13.8098855,21.8084982 13.349852,21.9989808 12.87,22 L12.87,22 Z M6.87,13.89 L12.87,19.89 L19.92,12.84 L13.92,6.84 L6.11,6.11 L6.87,13.89 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#000000",
    fillRule: "nonzero",
    cx: 10.5,
    cy: 10.5,
    r: 1.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(120.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    fill: "#8C9BA8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 34,
    height: 96
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon/Tag/M/White-Default",
    transform: "translate(5.000000, 36.000000)",
    filter: "url(#filter-4)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.87,22 C12.3871126,21.9994508 11.9237947,21.8090954 11.58,21.47 L5.17,15.05 C5.0055124,14.886454 4.90299461,14.6708131 4.88,14.44 L4,5.09 C3.97272602,4.79345526 4.07903692,4.5001838 4.29,4.29 C4.5001838,4.07903692 4.79345526,3.97272602 5.09,4 L14.44,4.88 C14.6708131,4.90299461 14.886454,5.0055124 15.05,5.17 L21.47,11.58 C22.178179,12.2903094 22.178179,13.4396906 21.47,14.15 L14.15,21.47 C13.8098855,21.8084982 13.349852,21.9989808 12.87,22 L12.87,22 Z M6.87,13.89 L12.87,19.89 L19.92,12.84 L13.92,6.84 L6.11,6.11 L6.87,13.89 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#000000",
    fillRule: "nonzero",
    cx: 10.5,
    cy: 10.5,
    r: 1.5
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProductGallery);
export default __webpack_public_path__ + "static/media/icon_product_gallery.b16b37e4.svg";
export { ForwardRef as ReactComponent };